import { Button, Stack, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '@@components/Loader';
import { useNavigationStore } from '@@scripts/store/useNavigationStore';

const LOADING_TIMEOUT = 1000;

const WrapperStack = styled(Stack)(({ theme }) => ({
    width: '100%',
    height: '100%',
    maxWidth: theme.fixed.errorPage.maxWidth,
    margin: '0 auto',
    padding: theme.spacing(5),
    alignItems: 'center',
    justifyContent: 'center',
}));

const Title = styled('h1')(({ theme }) => ({
    ...theme.typography.title1,
    marginBottom: theme.spacing(5),
    marginTop: 0,
}));

const Subtitle = styled('h2')(({ theme }) => ({
    ...theme.typography.large,
    whiteSpace: 'pre-line',
    textAlign: 'center',
}));

export const Error401 = () => {
    const { t } = useTranslation();
    const [isNavigating, setIsNavigating] = useState(useNavigationStore.getState().isNavigating);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            // Firefox does not fire the navigateerror event when the user presses cancel in the onbeforeunload prompt,
            // therefore we need to hide the loader manually after a timeout to prevent it from being stuck on
            // the screen.
            setIsNavigating(false);
        }, LOADING_TIMEOUT);

        return () => clearTimeout(timeoutId);
    }, []);

    if (isNavigating) {
        return (
            <WrapperStack>
                <Loader />
            </WrapperStack>
        );
    }

    return (
        <WrapperStack>
            <Title>{t('401.title')}</Title>
            <Subtitle>{t('401.subtitle')}</Subtitle>
            <Button color="secondary" variant="contained" onClick={() => window.location.reload()}>
                {t('401.button')}
            </Button>
        </WrapperStack>
    );
};
